// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/images/navbar-mobile-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 768px) {
  .sidebar {
    display: none;
  }

  .wallet-info-topbar h2 {
    font-size: 25px;
  }

  .wallet-balance-heading h2 span {
    margin-top: 30px;
    border-bottom: 4px solid #fbc425;
    font-size: 32px;
  }

  .wallet-info-topbar img {
    width: 16px;
    margin-top: 0px;
  }

  .back-arrow img {
    width: 50px;
    margin-top: 10px;
  }

  .wallet-info-topbar p {
    font-size: 20px;
    color: #5b5b5b;
    margin-top: 16px;
  }

  div#accountProfile_wrapper {
    padding-bottom: 30px;
  }

  .trasfer-histroy-wrapper-acc .transfer-history-header h3 {
    font-size: 32px !important;
  }

  .offcanvas-custom-large {
    width: 99%;
  }

  .transaction-detail-left {
    width: 100%;
  }

  .transaction-detail-right {
    width: 100%;
  }

  .dashboard-main-wrap {
    margin-left: 0px;
    margin-top: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 54px;
  }

  .nav-mobile-logo {
    display: block;
  }
  .nav-desktop-logo {
    display: none;
  }

  img.nav-mobile-logo {
    width: 78px;
  }

  .dashboard-card {
    width: 80%;
    height: 194px;
    margin: 0 auto;
  }

  .dashboard-card-2 {
    width: 80%;
    height: 194px;
    margin: 0 auto;
  }

  .navbar-profile-img {
    display: none;
  }

  .navbar-desktop {
    display: none;
  }

  .container-fluid {
    padding: 0px;
  }

  .mobile-navbar-wrapper {
    width: 100%;
    height: 80px;
    display: flex !important;
    justify-content: space-between;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    position: fixed;
    z-index: 999;
  }

  .mobile-nav-logo img {
    width: 120px;
    margin-left: 20px;
  }

  .navbar-nav .dropdown-menu {
    position: static;
    float: none;
    background: #003a3b;
    border: none;
    margin-top: -20px;
  }

  .nav-link:focus,
  .nav-link:hover {
    color: #fbc425;
  }

  .nav-link:focus {
    color: #fbc425;
  }

  .dropdown-item:focus,
  .dropdown-item:hover {
    color: #fbc425;
    background-color: transparent;
  }

  .mobile-navbar {
    display: block;
    margin-top: 25px;
  }

  .navbar-toggle-btn img {
    width: 100px;
  }

  .collapse.show {
    display: block;
    background: #00A19B;
    padding-bottom: 15px;
    margin-top: 20px;
  }

  .mobile-footer-wrap .collapse.show {
    background: transparent;
  }

  ul.navbar-nav.me-auto.mb-2.mb-lg-0 {
    background: #00A19B;
  }

  .navbar-toggler-icon {
    display: inline-block;
    width: 50px;
  }

  .navbar-toggler:not(:disabled):not(.disabled) {
    cursor: pointer;
    border: none;
    cursor: pointer;
    outline: none;
    height: 50px;
    margin-right: 20px;
  }

  .navbar-toggler:focus {
    box-shadow: unset !important;
}


  li.nav-item a {
    color: #fff;
    font-size: 20px;
    margin-top: 16px;
    margin-left: 31px;
  }

  /* .mobile-nav-logo img {
    width: 100%;
  } */

  .mobile-navbar ul li a {
    color: #fff;
    text-decoration: none;
    font-size: 20px;
  }

  .mobile-navbar ul {
    display: inline-flex;
    margin-bottom: 0px;
  }

  .mobile-navbar ul li {
    text-decoration: none;
    list-style: none;
    margin-left: 20px;
    color: #fff !important;
    cursor: pointer;
  }

  div.dataTables_wrapper div.dataTables_paginate ul.pagination {
    justify-content: center !important;
    bottom: 5px;
    background: #ffff;
  }

  .admin-user-table-wrapper {
    width: 100%;
  }

  .admin-user-table-wrapper div#principle_wrapper {
    width: 800px;
  }

  .account-profile-left {
    display: flex;
    flex-direction: column;
    gap: 0px;
    justify-content: center;
    align-items: center;
    margin-top: -90px;
  }

  .account-profile-info .username h3 {
    font-size: 24px;
    padding-bottom: 2px;
}

  .account-profile-info .username p {
    font-size: 18px;
  }

  .account-detail-profile-wrap {
    flex-direction: column;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
}

  .account-info-wrap {
    display: flex;
    gap: 10px;
    padding-bottom: 20px;
  }

  .account-profile-info .username {
    margin-bottom: 31px;
    text-align: center;
  }

  .account-info-wrap h4 {
    min-width: 150px;
    font-size: 16px;
  }

  .account-info-wrap h5 {
    font-size: 16px;
  }

  .account-profile-right h2 {
    font-size: 35px;
  }

  .account-profile-right h3 {
    font-size: 40px;
  }

  .account-detail-profile-wrapper {
    margin-top: 25px;
  }

  .account-detail-Txt {
    display: none;
  }

  .profile-activity-wrapper h2 {
    font-size: 20px;
    font-weight: 600;
    color: #383838;
    margin-bottom: 20px;
  }

  .wallet-balance-table-main-wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-top: 40px;
  }

  .wallet-balance-table-wrapper {
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    gap: 20px;
    margin-top: 40px;
  }

  .wallet-balance-heading h2 {
    font-size: 35px;
    min-width: 150px;
    text-align: center;
    margin-bottom: 20px;
  }

  table#principle1 {
    margin-bottom: 30px;
  }

  .acc-transaction-header-wrapper {
    position: fixed;
    width: 95%;
  }

  .account-detail-header {
    display: block;
  }

  .acc-transaction-header p {
    font-size: 20px;
    margin: 0px;
  }

  .acc-transaction-header {
    gap: 20px;
    justify-content: center;
  }

  .transactin-detail {
    justify-content: center;
  }

  .transactin-detail h2 {
    font-size: 32px;
  }

  .admin-page-header h2 {
    font-size: 26px;
  }

  .transfer-history-header h3 {
    font-size: 26px;
  }

  .transfer-admin-history-wrap {
    margin-left: 0px;
  }

  .transactin-detail img {
    width: 60px;
  }

  .admin-page-header img {
    width: 60px;
  }

  .admin-page-header {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .transfer-history-header {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .transaction-detail-wrapper {
    display: flex;
    flex-direction: column;
    gap: 70px;
  }

  .transaction-detail-wrapper h3 {
    width: 245px;
    font-size: 26px;
  }
  .transaction-info-wrap h4 {
    min-width: 160px;
    font-size: 20px;
  }

  .transaction-total-wrap {
    gap: 10px;
  }

  table.table.table-striped thead,
  tr,
  th {
    font-size: 16px !important;
  }

  .table > :not(caption) > * > * {
    font-size: 16px;
}

  .transaction-info-wrap h5 {
    font-size: 19px;
  }

  .transaction-total-wrap h5 {
    font-size: 19px;
  }

  .transaction-total-wrap h4 {
    min-width: 140px;
    font-size: 20px;
  }

  .transaction-info-wrap {
    display: flex;
    gap: 5px;
    margin-bottom: 25px;
  }

.contractor-edit-profile {
    display: flex;
    justify-content: flex-start;
}

.contractor-edit-profile img{
  display: none;
}

  .account-detail-header h2 {
    text-align: left;
    font-size: 22px;
  }

  .transaction-header-main-wrap {
    display: flex;
    flex-direction: column;
    gap: 0px;
    justify-content: flex-start;
    align-items: baseline;
}

.account-search-main-wrap {
  margin-top: 10px;
}

.account-page-wrapper .account-search-main-wrap {
  margin-top: 30px;
}

}

@media (min-width: 768px) and (max-width: 1024px) {
  .sidebar {
    height: 90vh;
    padding-bottom: 10px;
  }

  .wallet-info-topbar h2 {
    font-size: 45px;
    color: #383838;
    margin: 0px;
  }

  .account-profile-right h3 {
    font-size: 35px;
  }

  .account-profile-right button {
    padding: 8px 30px;
    font-size: 22px;
    font-weight: 500;
    margin-top: 25px;
  }

  .admin-page-header {
    padding: 10px;
  }

  .account-header-left {
    display: none;
  }

  .mobile-filter-wrap {
    width: 200px;
    margin-top: 20px;
    padding: 15px 10px;
    border: 1px solid var(--buttonColor);
    border-radius: 5px;
    outline: none;
    color: #383838;
    font-size: 16px;
    font-weight: 300;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    cursor: pointer;
}

  .admin-page-header img {
    width: 62px;
  }

  .admin-page-header h2 {
    font-size: 28px;
  }

  .transfer-history-header h3 {
    font-size: 28px;
  }

  .transfer-history-header {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .transactin-detail h2 {
    font-size: 35px;
  }

  .transaction-detail-wrapper h3 {
    width: 250px;
    font-size: 26px;
  }

  .transaction-info-wrap h4 {
    min-width: 200px;
    font-size: 20px;
  }

  .transaction-detail-left {
    width: 100%;
  }

  .transaction-detail-right {
    width: 100%;
  }

  .spacing-wrapper {
    margin-left: 155px;
  }

  div#principle_length select,
  div#principle1_length select {
    /* position: absolute; */
    width: 80px;
  }

  .wallet-info-table-wrapper table#principle {
    margin-top: 30px;
  }

  .account-table-wrapper table#principle {
    text-align: center;
    /* margin-top: 50px; */
    margin-top: 10px;
  }

  .wallet-transation-table-wrapper table#principle {
    margin-top: 20px;
  }

  table#principle1 {
    margin-top: 50px;
  }

  .dashboard-main-wrap {
    margin-left: 0px !important;
    display: flex;
    flex-direction: column;
    gap: 54px;
    justify-content: center;
    align-items: center;
  }

  .admin-user-table-wrapper div#principle_wrapper {
    width: 600px;
  }

  .admin-user-table-wrapper {
    width: 100% !important;
  }

  .wallet-balance-table-main-wrapper,
  .wallet-balance-table-wrapper {
    display: block !important;
  }

  .wallet-balance-heading {
    width: 150px;
    margin: 0 auto;
    margin-bottom: 30px;
  }

  .wallet-balance-heading h2 span {
    margin-top: 30px;
    border-bottom: 4px solid #fbc425;
    font-size: 35px !important;
  }

  .account-detail-header h3 {
    font-size: 20px;
  }

  .account-tab-active h3 {
    font-size: 20px;
  }

  .account-detail-header {
    gap: 20px;
  }

  .account-detail-header h2 {
    font-size: 30px;
    color: #383838;
  }

  .account-detail-tabs-wrap {
    display: flex;
    gap: 20px;
  }

  .account-detail-profile-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 30px;
  }

  .profile-activity-wrapper {
    margin-top: 60px;
  }

  .create-order-dropdwon .select-box-wrapper label {
    font-size: 20px;
  }

  .account-profile-left {
    display: block;
    margin-top: 30px;
  }

  .account-profile-info .username {
    margin-bottom: 31px;
    text-align: center;
    margin-top: 20px;
  }

  .contractor-application-status {
    margin-top: 0px;
    margin-left: 100px;
}

  .account-info-wrap {
    display: flex;
    gap: 33px;
  }

  .account-info-wrapper {
    margin-left: 50px;
  }

  .account-profile {
    text-align: center;
  }

  .account-detail-profile-wrapper {
    margin-top: 10px;
  }

  /* .account-profile-right {
    display: none;
  } */

  .account-profile img {
    margin-top: -40px;
  }

  .profile-activity-table div#accountProfile_wrapper {
    width: 1100px;
  }

  .account-detail-left-tabs-wrap {
    display: none;
  }
  .acc-transaction-header {
    gap: 25%;
  }

  .transaction-detail-wrapper {
    display: block;
  }
  .transaction-detail-left {
    /* text-align: center; */
    margin-left: 15px;
  }

  .transactin-detail {
    justify-content: center;
  }

  .transaction-detail-right {
    margin-top: 80px;
    margin-left: 15px;
  }

  .transaction-info-wrap h5 {
    font-size: 19px;
    word-break: break-all;
  }

  table.table.table-striped thead,
  tr,
  th {
    font-size: 18px !important;
  }

  .transaction-total-wrap h5 {
    font-size: 19px;
  }

  .transaction-total-wrap h4 {
    min-width: 135px;
  }

  .transaction-total-wrap {
    gap: 30px;
  }

  div#principle_wrapper {
    width: 1500px;
  }

  div#principle1_wrapper {
    width: 1500px;
  }
  div#example_wrapper {
    width: 1500px;
  }

  .tranfer-history-dropdown-wrapper.table-responsive {
    height: calc(100vh - 350px);
    overflow: auto;
}

}

@media (min-width: 1025px) and (max-width: 1599px) {
  div#principle_length select,
  div#principle1_length select {
    /* position: absolute; */
    width: 80px;
  }

  .wallet-balance-heading h2 span {
    font-size: 35px;
  }

  h2.wallet-box-text {
    margin-top: 40px;
  }

  /* .wallet-balance-heading {
    margin-top: 40px;
  } */

  div.dataTables_wrapper div.dataTables_paginate {
    /* margin-right: 100px; */
    /* position: fixed; */
    right: 16%;
    bottom: 20px;
    background: #ffff;
    margin-left: 70%;
  }

  .wallet-info-topbar h2 {
    font-size: 45px;
    color: #383838;
    margin: 0px;
  }

  table#principle1 {
    margin-top: 50px;
  }

  .wallet-info-table-wrapper table#principle {
    margin-top: 30px;
  }

  .account-table-wrapper table#principle {
    text-align: center;
    margin-top: 10px;
  }
  .wallet-transation-table-wrapper table#principle {
    margin-top: 20px;
  }

  .account-table-wrapper div#principle_wrapper {
    width: 1300px;
  }

  .spacing-wrapper {
    margin-left: 140px;
  }

  .principle-table-holder div#principle_wrapper,
  .principle-open-wrapper div#example_wrapper {
    width: 1540px;
  }

  .tranfer-history-dropdown-wrapper div#principle_wrapper {
    width: 1400px;
  }
  .wallet-transation-table-wrapper div#principle_wrapper {
    width: 1300px;
  }

  .wallet-transation-table-wrapper div#principle1_wrapper {
    width: 1300px;
  }

  .account-info-wrap {
    display: flex;
    gap: 36px;
    padding-bottom: 16px;
  }

  .account-detail-profile-wrap {
    display: flex;
    margin-top: 0px;
    gap: 0px;
    justify-content: space-between;
  }

  .account-info-wrap h4 {
    min-width: 140px;
    font-size: 16px;
    color: #383838;
  }

  .account-info-wrap h5 {
    white-space: nowrap;
    font-size: 16px;
    color: #5B5B5B;
  }

  .account-profile-right img {
    width: 90px;
    height: auto;
  }

  
    img.dropdown-down-arrow {
        width: 14px;
    }

  .account-profile-right h4 {
      font-size: 20px;
      font-weight: 500;
      margin-top: 15px;
  }

  .account-profile-left {
    gap: 20px;
  }

  .account-profile-right h3 {
    font-size: 35px;
    color: #25e101;
  }

  .account-profile-right button {
    font-size: 20px;
    padding: 8px 24px;
    font-weight: 500;
    margin-top: 10px;
    height: 55px;
    width: 240px;
  }

  .profile-activity-wrapper h2 {
    font-size: 24px;
    color: #383838;
    margin-bottom: 20px;  
  }

  .profile-activity-wrapper {
    margin-top: 40px;
}

  .acc-transaction-header-wrapper {
    position: fixed;
    width: 80%;
  }

  .account-detail-left-tabs-wrap {
    margin-right: 0px;
  }

  .account-detail-header {
    gap: 60px;
    padding: 12px;
  }

  .account-detail-header h2 {
    font-size: 28px;
    color: #383838;
  }

  .account-detail-left-tabs-wrap h3 {
    font-size: 18px;
  }

  .account-detail-header h3 {
    font-size: 20px;
  }

  .account-detail-tabs-wrap {
    gap: 20px;
  }

  .acc-transaction-header {
    gap: 30%;
  }

  .transaction-info-wrap {
    display: flex;
    gap: 15px;
    padding-bottom: 20px;
  }
  .transaction-info-wrap h4 {
    min-width: 180px;
    font-size: 20px;
  }
  .transaction-info-wrap h5 {
    font-size: 19px;
  }
  .transaction-detail-wrapper h3 {
    width: 270px;
    font-size: 28px;
  }

  .admin-page-header h2 {
    font-size: 30px;
    color: #383838;
  }

  .admin-page-header img {
    width: 60px;
  }

  .admin-page-header {
    padding: 12px;
  }

  table.table.table-striped thead, tr, th {
    font-size: 17px !important;
  }

  table.table.table-striped thead, tr, td {
    font-size: 16px !important;
  }


  .tranfer-history-dropdown-wrapper.table-responsive {
    height: calc(100vh - 350px);
    overflow: auto;
  }


  .transaction-detail-wrapper span.time {
    margin-left: 10px;
  }

  .transactin-detail h2 {
    font-size: 35px;
  }

  .transaction-total-wrap h4 {
    min-width: 130px;
    margin: 0px;
  }
  .transaction-total-wrap h5 {
    font-size: 22px;
    min-width: 150px;
  }

  .transaction-total-wrap {
    gap: 120px;
  }

  .admin-user-table-wrapper {
    width: 70%;
  }


}

@media (min-width: 420px) and (max-width: 768px) {
  .dashboard-card {
    width: 330px;
    height: 194px;
    margin: 0 auto;
  }

  .dashboard-card-2 {
    width: 330px;
    height: 194px;
    margin: 0 auto;
  }

  .acc-transaction-header-wrapper {
    position: fixed;
    width: 90%;
  }

  .acc-transaction-header-wrapper {
    position: fixed;
    width: 90%;
  }
}

@media (min-width: 576px) {
  .container,
  .container-sm {
    max-width: 90%;
  }
}

@media (min-width: 1600px) {
  .acc-transaction-header-wrapper {
    position: fixed;
    width: 82%;
  }

  h2.wallet-box-text {
    margin-top: 40px;
  }

  .wallet-balance-table-main-wrapper {
    display: flex;
    width: 57%;
  }

  .balance-acc {
    margin: 0 auto;
    margin-top: 81px;
  }

  .wallet-table-wrap2 {
    width: 57%;
  }

  .spacing-wrapper {
    margin-left: 150px;
  }

  .offcanvas-custom-large {
    width: 700px !important;
  }

  div.dataTables_wrapper div.dataTables_paginate {
    /* margin-right: 100px; */
    /* position: fixed; */
    right: 16%;
    bottom: 20px;
    background: #ffff;
    margin-left: 80%;
  }
}

@media (min-width: 768px) and (max-width: 880px) {
  .filter-select-wraper {
    gap: 8px;
  }
}



@media(min-width: 768px) and (max-width: 1199px){
  .fiter-dropdown {
    display: none;
}

.admin-user-table-wrapper {
  width: 80%;
}

  .fiter-dropdown-mobile {
    display: block;
  }

  .mobile-filter-wrap {
    width: 200px;
    margin-top: 20px;
    padding: 15px 10px;
    border: 1px solid var(--buttonColor);
    border-radius: 5px;
    outline: none;
    color: #383838;
    font-size: 16px;
    font-weight: 300;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    cursor: pointer;
}

.mobile-filter-wrap h3 {
    font-size: 20px;
    margin: 0px;
  }

  .mobile-filter-wrap img{
    width: 18px;
  }

  .transfer-history-header img {
    width: 60px;
}

.search-icon img {
  width: 20px;
}

table.table.table-striped thead, tr, th {
  font-size: 16px !important;
}


}`, "",{"version":3,"sources":["webpack://./src/responsive.css"],"names":[],"mappings":"AAAA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;IACV,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,8BAA8B;IAC9B,yDAA6D;IAC7D,eAAe;IACf,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,cAAc;IACd,6BAA6B;EAC/B;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,eAAe;IACf,aAAa;IACb,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;AAChC;;;EAGE;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;KAEG;;EAEH;IACE,WAAW;IACX,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,kCAAkC;IAClC,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;AACvB;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;EAEE;IACE,aAAa;IACb,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;AACnB;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,mBAAmB;EACrB;;AAEF;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;EACE,aAAa;AACf;;EAEE;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;AAEA;EACE;IACE,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,oCAAoC;IACpC,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,eAAe;AACnB;;EAEE;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,wBAAwB;IACxB,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,gCAAgC;IAChC,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;AACtB;;EAEE;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;KAEG;;EAEH;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;EACA;IACE,QAAQ;EACV;;EAEA;IACE,cAAc;EAChB;EACA;IACE,wBAAwB;IACxB,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;;EAEA;IACE,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;;AAEA;EACE;;IAEE,wBAAwB;IACxB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;KAEG;;EAEH;IACE,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,QAAQ;IACR,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;;IAGE;QACI,WAAW;IACf;;EAEF;MACI,eAAe;MACf,gBAAgB;MAChB,gBAAgB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;IACf,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;AACpB;;EAEE;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,aAAa;EACf;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,SAAS;IACT,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;;EAGA;IACE,2BAA2B;IAC3B,cAAc;EAChB;;;EAGA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;;AAGF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,QAAQ;EACV;AACF;;;;AAIA;EACE;IACE,aAAa;AACjB;;AAEA;EACE,UAAU;AACZ;;EAEE;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,oCAAoC;IACpC,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA","sourcesContent":["@media (max-width: 768px) {\n  .sidebar {\n    display: none;\n  }\n\n  .wallet-info-topbar h2 {\n    font-size: 25px;\n  }\n\n  .wallet-balance-heading h2 span {\n    margin-top: 30px;\n    border-bottom: 4px solid #fbc425;\n    font-size: 32px;\n  }\n\n  .wallet-info-topbar img {\n    width: 16px;\n    margin-top: 0px;\n  }\n\n  .back-arrow img {\n    width: 50px;\n    margin-top: 10px;\n  }\n\n  .wallet-info-topbar p {\n    font-size: 20px;\n    color: #5b5b5b;\n    margin-top: 16px;\n  }\n\n  div#accountProfile_wrapper {\n    padding-bottom: 30px;\n  }\n\n  .trasfer-histroy-wrapper-acc .transfer-history-header h3 {\n    font-size: 32px !important;\n  }\n\n  .offcanvas-custom-large {\n    width: 99%;\n  }\n\n  .transaction-detail-left {\n    width: 100%;\n  }\n\n  .transaction-detail-right {\n    width: 100%;\n  }\n\n  .dashboard-main-wrap {\n    margin-left: 0px;\n    margin-top: 80px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 54px;\n  }\n\n  .nav-mobile-logo {\n    display: block;\n  }\n  .nav-desktop-logo {\n    display: none;\n  }\n\n  img.nav-mobile-logo {\n    width: 78px;\n  }\n\n  .dashboard-card {\n    width: 80%;\n    height: 194px;\n    margin: 0 auto;\n  }\n\n  .dashboard-card-2 {\n    width: 80%;\n    height: 194px;\n    margin: 0 auto;\n  }\n\n  .navbar-profile-img {\n    display: none;\n  }\n\n  .navbar-desktop {\n    display: none;\n  }\n\n  .container-fluid {\n    padding: 0px;\n  }\n\n  .mobile-navbar-wrapper {\n    width: 100%;\n    height: 80px;\n    display: flex !important;\n    justify-content: space-between;\n    background-image: url(\"./assets/images/navbar-mobile-bg.png\");\n    position: fixed;\n    z-index: 999;\n  }\n\n  .mobile-nav-logo img {\n    width: 120px;\n    margin-left: 20px;\n  }\n\n  .navbar-nav .dropdown-menu {\n    position: static;\n    float: none;\n    background: #003a3b;\n    border: none;\n    margin-top: -20px;\n  }\n\n  .nav-link:focus,\n  .nav-link:hover {\n    color: #fbc425;\n  }\n\n  .nav-link:focus {\n    color: #fbc425;\n  }\n\n  .dropdown-item:focus,\n  .dropdown-item:hover {\n    color: #fbc425;\n    background-color: transparent;\n  }\n\n  .mobile-navbar {\n    display: block;\n    margin-top: 25px;\n  }\n\n  .navbar-toggle-btn img {\n    width: 100px;\n  }\n\n  .collapse.show {\n    display: block;\n    background: #00A19B;\n    padding-bottom: 15px;\n    margin-top: 20px;\n  }\n\n  .mobile-footer-wrap .collapse.show {\n    background: transparent;\n  }\n\n  ul.navbar-nav.me-auto.mb-2.mb-lg-0 {\n    background: #00A19B;\n  }\n\n  .navbar-toggler-icon {\n    display: inline-block;\n    width: 50px;\n  }\n\n  .navbar-toggler:not(:disabled):not(.disabled) {\n    cursor: pointer;\n    border: none;\n    cursor: pointer;\n    outline: none;\n    height: 50px;\n    margin-right: 20px;\n  }\n\n  .navbar-toggler:focus {\n    box-shadow: unset !important;\n}\n\n\n  li.nav-item a {\n    color: #fff;\n    font-size: 20px;\n    margin-top: 16px;\n    margin-left: 31px;\n  }\n\n  /* .mobile-nav-logo img {\n    width: 100%;\n  } */\n\n  .mobile-navbar ul li a {\n    color: #fff;\n    text-decoration: none;\n    font-size: 20px;\n  }\n\n  .mobile-navbar ul {\n    display: inline-flex;\n    margin-bottom: 0px;\n  }\n\n  .mobile-navbar ul li {\n    text-decoration: none;\n    list-style: none;\n    margin-left: 20px;\n    color: #fff !important;\n    cursor: pointer;\n  }\n\n  div.dataTables_wrapper div.dataTables_paginate ul.pagination {\n    justify-content: center !important;\n    bottom: 5px;\n    background: #ffff;\n  }\n\n  .admin-user-table-wrapper {\n    width: 100%;\n  }\n\n  .admin-user-table-wrapper div#principle_wrapper {\n    width: 800px;\n  }\n\n  .account-profile-left {\n    display: flex;\n    flex-direction: column;\n    gap: 0px;\n    justify-content: center;\n    align-items: center;\n    margin-top: -90px;\n  }\n\n  .account-profile-info .username h3 {\n    font-size: 24px;\n    padding-bottom: 2px;\n}\n\n  .account-profile-info .username p {\n    font-size: 18px;\n  }\n\n  .account-detail-profile-wrap {\n    flex-direction: column;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n}\n\n  .account-info-wrap {\n    display: flex;\n    gap: 10px;\n    padding-bottom: 20px;\n  }\n\n  .account-profile-info .username {\n    margin-bottom: 31px;\n    text-align: center;\n  }\n\n  .account-info-wrap h4 {\n    min-width: 150px;\n    font-size: 16px;\n  }\n\n  .account-info-wrap h5 {\n    font-size: 16px;\n  }\n\n  .account-profile-right h2 {\n    font-size: 35px;\n  }\n\n  .account-profile-right h3 {\n    font-size: 40px;\n  }\n\n  .account-detail-profile-wrapper {\n    margin-top: 25px;\n  }\n\n  .account-detail-Txt {\n    display: none;\n  }\n\n  .profile-activity-wrapper h2 {\n    font-size: 20px;\n    font-weight: 600;\n    color: #383838;\n    margin-bottom: 20px;\n  }\n\n  .wallet-balance-table-main-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    margin-top: 40px;\n  }\n\n  .wallet-balance-table-wrapper {\n    display: flex;\n    flex-direction: column;\n    /* align-items: center; */\n    gap: 20px;\n    margin-top: 40px;\n  }\n\n  .wallet-balance-heading h2 {\n    font-size: 35px;\n    min-width: 150px;\n    text-align: center;\n    margin-bottom: 20px;\n  }\n\n  table#principle1 {\n    margin-bottom: 30px;\n  }\n\n  .acc-transaction-header-wrapper {\n    position: fixed;\n    width: 95%;\n  }\n\n  .account-detail-header {\n    display: block;\n  }\n\n  .acc-transaction-header p {\n    font-size: 20px;\n    margin: 0px;\n  }\n\n  .acc-transaction-header {\n    gap: 20px;\n    justify-content: center;\n  }\n\n  .transactin-detail {\n    justify-content: center;\n  }\n\n  .transactin-detail h2 {\n    font-size: 32px;\n  }\n\n  .admin-page-header h2 {\n    font-size: 26px;\n  }\n\n  .transfer-history-header h3 {\n    font-size: 26px;\n  }\n\n  .transfer-admin-history-wrap {\n    margin-left: 0px;\n  }\n\n  .transactin-detail img {\n    width: 60px;\n  }\n\n  .admin-page-header img {\n    width: 60px;\n  }\n\n  .admin-page-header {\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n\n  .transfer-history-header {\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n\n  .transaction-detail-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 70px;\n  }\n\n  .transaction-detail-wrapper h3 {\n    width: 245px;\n    font-size: 26px;\n  }\n  .transaction-info-wrap h4 {\n    min-width: 160px;\n    font-size: 20px;\n  }\n\n  .transaction-total-wrap {\n    gap: 10px;\n  }\n\n  table.table.table-striped thead,\n  tr,\n  th {\n    font-size: 16px !important;\n  }\n\n  .table > :not(caption) > * > * {\n    font-size: 16px;\n}\n\n  .transaction-info-wrap h5 {\n    font-size: 19px;\n  }\n\n  .transaction-total-wrap h5 {\n    font-size: 19px;\n  }\n\n  .transaction-total-wrap h4 {\n    min-width: 140px;\n    font-size: 20px;\n  }\n\n  .transaction-info-wrap {\n    display: flex;\n    gap: 5px;\n    margin-bottom: 25px;\n  }\n\n.contractor-edit-profile {\n    display: flex;\n    justify-content: flex-start;\n}\n\n.contractor-edit-profile img{\n  display: none;\n}\n\n  .account-detail-header h2 {\n    text-align: left;\n    font-size: 22px;\n  }\n\n  .transaction-header-main-wrap {\n    display: flex;\n    flex-direction: column;\n    gap: 0px;\n    justify-content: flex-start;\n    align-items: baseline;\n}\n\n.account-search-main-wrap {\n  margin-top: 10px;\n}\n\n.account-page-wrapper .account-search-main-wrap {\n  margin-top: 30px;\n}\n\n}\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .sidebar {\n    height: 90vh;\n    padding-bottom: 10px;\n  }\n\n  .wallet-info-topbar h2 {\n    font-size: 45px;\n    color: #383838;\n    margin: 0px;\n  }\n\n  .account-profile-right h3 {\n    font-size: 35px;\n  }\n\n  .account-profile-right button {\n    padding: 8px 30px;\n    font-size: 22px;\n    font-weight: 500;\n    margin-top: 25px;\n  }\n\n  .admin-page-header {\n    padding: 10px;\n  }\n\n  .account-header-left {\n    display: none;\n  }\n\n  .mobile-filter-wrap {\n    width: 200px;\n    margin-top: 20px;\n    padding: 15px 10px;\n    border: 1px solid var(--buttonColor);\n    border-radius: 5px;\n    outline: none;\n    color: #383838;\n    font-size: 16px;\n    font-weight: 300;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 20px;\n    cursor: pointer;\n}\n\n  .admin-page-header img {\n    width: 62px;\n  }\n\n  .admin-page-header h2 {\n    font-size: 28px;\n  }\n\n  .transfer-history-header h3 {\n    font-size: 28px;\n  }\n\n  .transfer-history-header {\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n\n  .transactin-detail h2 {\n    font-size: 35px;\n  }\n\n  .transaction-detail-wrapper h3 {\n    width: 250px;\n    font-size: 26px;\n  }\n\n  .transaction-info-wrap h4 {\n    min-width: 200px;\n    font-size: 20px;\n  }\n\n  .transaction-detail-left {\n    width: 100%;\n  }\n\n  .transaction-detail-right {\n    width: 100%;\n  }\n\n  .spacing-wrapper {\n    margin-left: 155px;\n  }\n\n  div#principle_length select,\n  div#principle1_length select {\n    /* position: absolute; */\n    width: 80px;\n  }\n\n  .wallet-info-table-wrapper table#principle {\n    margin-top: 30px;\n  }\n\n  .account-table-wrapper table#principle {\n    text-align: center;\n    /* margin-top: 50px; */\n    margin-top: 10px;\n  }\n\n  .wallet-transation-table-wrapper table#principle {\n    margin-top: 20px;\n  }\n\n  table#principle1 {\n    margin-top: 50px;\n  }\n\n  .dashboard-main-wrap {\n    margin-left: 0px !important;\n    display: flex;\n    flex-direction: column;\n    gap: 54px;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .admin-user-table-wrapper div#principle_wrapper {\n    width: 600px;\n  }\n\n  .admin-user-table-wrapper {\n    width: 100% !important;\n  }\n\n  .wallet-balance-table-main-wrapper,\n  .wallet-balance-table-wrapper {\n    display: block !important;\n  }\n\n  .wallet-balance-heading {\n    width: 150px;\n    margin: 0 auto;\n    margin-bottom: 30px;\n  }\n\n  .wallet-balance-heading h2 span {\n    margin-top: 30px;\n    border-bottom: 4px solid #fbc425;\n    font-size: 35px !important;\n  }\n\n  .account-detail-header h3 {\n    font-size: 20px;\n  }\n\n  .account-tab-active h3 {\n    font-size: 20px;\n  }\n\n  .account-detail-header {\n    gap: 20px;\n  }\n\n  .account-detail-header h2 {\n    font-size: 30px;\n    color: #383838;\n  }\n\n  .account-detail-tabs-wrap {\n    display: flex;\n    gap: 20px;\n  }\n\n  .account-detail-profile-wrap {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: 30px;\n  }\n\n  .profile-activity-wrapper {\n    margin-top: 60px;\n  }\n\n  .create-order-dropdwon .select-box-wrapper label {\n    font-size: 20px;\n  }\n\n  .account-profile-left {\n    display: block;\n    margin-top: 30px;\n  }\n\n  .account-profile-info .username {\n    margin-bottom: 31px;\n    text-align: center;\n    margin-top: 20px;\n  }\n\n  .contractor-application-status {\n    margin-top: 0px;\n    margin-left: 100px;\n}\n\n  .account-info-wrap {\n    display: flex;\n    gap: 33px;\n  }\n\n  .account-info-wrapper {\n    margin-left: 50px;\n  }\n\n  .account-profile {\n    text-align: center;\n  }\n\n  .account-detail-profile-wrapper {\n    margin-top: 10px;\n  }\n\n  /* .account-profile-right {\n    display: none;\n  } */\n\n  .account-profile img {\n    margin-top: -40px;\n  }\n\n  .profile-activity-table div#accountProfile_wrapper {\n    width: 1100px;\n  }\n\n  .account-detail-left-tabs-wrap {\n    display: none;\n  }\n  .acc-transaction-header {\n    gap: 25%;\n  }\n\n  .transaction-detail-wrapper {\n    display: block;\n  }\n  .transaction-detail-left {\n    /* text-align: center; */\n    margin-left: 15px;\n  }\n\n  .transactin-detail {\n    justify-content: center;\n  }\n\n  .transaction-detail-right {\n    margin-top: 80px;\n    margin-left: 15px;\n  }\n\n  .transaction-info-wrap h5 {\n    font-size: 19px;\n    word-break: break-all;\n  }\n\n  table.table.table-striped thead,\n  tr,\n  th {\n    font-size: 18px !important;\n  }\n\n  .transaction-total-wrap h5 {\n    font-size: 19px;\n  }\n\n  .transaction-total-wrap h4 {\n    min-width: 135px;\n  }\n\n  .transaction-total-wrap {\n    gap: 30px;\n  }\n\n  div#principle_wrapper {\n    width: 1500px;\n  }\n\n  div#principle1_wrapper {\n    width: 1500px;\n  }\n  div#example_wrapper {\n    width: 1500px;\n  }\n\n  .tranfer-history-dropdown-wrapper.table-responsive {\n    height: calc(100vh - 350px);\n    overflow: auto;\n}\n\n}\n\n@media (min-width: 1025px) and (max-width: 1599px) {\n  div#principle_length select,\n  div#principle1_length select {\n    /* position: absolute; */\n    width: 80px;\n  }\n\n  .wallet-balance-heading h2 span {\n    font-size: 35px;\n  }\n\n  h2.wallet-box-text {\n    margin-top: 40px;\n  }\n\n  /* .wallet-balance-heading {\n    margin-top: 40px;\n  } */\n\n  div.dataTables_wrapper div.dataTables_paginate {\n    /* margin-right: 100px; */\n    /* position: fixed; */\n    right: 16%;\n    bottom: 20px;\n    background: #ffff;\n    margin-left: 70%;\n  }\n\n  .wallet-info-topbar h2 {\n    font-size: 45px;\n    color: #383838;\n    margin: 0px;\n  }\n\n  table#principle1 {\n    margin-top: 50px;\n  }\n\n  .wallet-info-table-wrapper table#principle {\n    margin-top: 30px;\n  }\n\n  .account-table-wrapper table#principle {\n    text-align: center;\n    margin-top: 10px;\n  }\n  .wallet-transation-table-wrapper table#principle {\n    margin-top: 20px;\n  }\n\n  .account-table-wrapper div#principle_wrapper {\n    width: 1300px;\n  }\n\n  .spacing-wrapper {\n    margin-left: 140px;\n  }\n\n  .principle-table-holder div#principle_wrapper,\n  .principle-open-wrapper div#example_wrapper {\n    width: 1540px;\n  }\n\n  .tranfer-history-dropdown-wrapper div#principle_wrapper {\n    width: 1400px;\n  }\n  .wallet-transation-table-wrapper div#principle_wrapper {\n    width: 1300px;\n  }\n\n  .wallet-transation-table-wrapper div#principle1_wrapper {\n    width: 1300px;\n  }\n\n  .account-info-wrap {\n    display: flex;\n    gap: 36px;\n    padding-bottom: 16px;\n  }\n\n  .account-detail-profile-wrap {\n    display: flex;\n    margin-top: 0px;\n    gap: 0px;\n    justify-content: space-between;\n  }\n\n  .account-info-wrap h4 {\n    min-width: 140px;\n    font-size: 16px;\n    color: #383838;\n  }\n\n  .account-info-wrap h5 {\n    white-space: nowrap;\n    font-size: 16px;\n    color: #5B5B5B;\n  }\n\n  .account-profile-right img {\n    width: 90px;\n    height: auto;\n  }\n\n  \n    img.dropdown-down-arrow {\n        width: 14px;\n    }\n\n  .account-profile-right h4 {\n      font-size: 20px;\n      font-weight: 500;\n      margin-top: 15px;\n  }\n\n  .account-profile-left {\n    gap: 20px;\n  }\n\n  .account-profile-right h3 {\n    font-size: 35px;\n    color: #25e101;\n  }\n\n  .account-profile-right button {\n    font-size: 20px;\n    padding: 8px 24px;\n    font-weight: 500;\n    margin-top: 10px;\n    height: 55px;\n    width: 240px;\n  }\n\n  .profile-activity-wrapper h2 {\n    font-size: 24px;\n    color: #383838;\n    margin-bottom: 20px;  \n  }\n\n  .profile-activity-wrapper {\n    margin-top: 40px;\n}\n\n  .acc-transaction-header-wrapper {\n    position: fixed;\n    width: 80%;\n  }\n\n  .account-detail-left-tabs-wrap {\n    margin-right: 0px;\n  }\n\n  .account-detail-header {\n    gap: 60px;\n    padding: 12px;\n  }\n\n  .account-detail-header h2 {\n    font-size: 28px;\n    color: #383838;\n  }\n\n  .account-detail-left-tabs-wrap h3 {\n    font-size: 18px;\n  }\n\n  .account-detail-header h3 {\n    font-size: 20px;\n  }\n\n  .account-detail-tabs-wrap {\n    gap: 20px;\n  }\n\n  .acc-transaction-header {\n    gap: 30%;\n  }\n\n  .transaction-info-wrap {\n    display: flex;\n    gap: 15px;\n    padding-bottom: 20px;\n  }\n  .transaction-info-wrap h4 {\n    min-width: 180px;\n    font-size: 20px;\n  }\n  .transaction-info-wrap h5 {\n    font-size: 19px;\n  }\n  .transaction-detail-wrapper h3 {\n    width: 270px;\n    font-size: 28px;\n  }\n\n  .admin-page-header h2 {\n    font-size: 30px;\n    color: #383838;\n  }\n\n  .admin-page-header img {\n    width: 60px;\n  }\n\n  .admin-page-header {\n    padding: 12px;\n  }\n\n  table.table.table-striped thead, tr, th {\n    font-size: 17px !important;\n  }\n\n  table.table.table-striped thead, tr, td {\n    font-size: 16px !important;\n  }\n\n\n  .tranfer-history-dropdown-wrapper.table-responsive {\n    height: calc(100vh - 350px);\n    overflow: auto;\n  }\n\n\n  .transaction-detail-wrapper span.time {\n    margin-left: 10px;\n  }\n\n  .transactin-detail h2 {\n    font-size: 35px;\n  }\n\n  .transaction-total-wrap h4 {\n    min-width: 130px;\n    margin: 0px;\n  }\n  .transaction-total-wrap h5 {\n    font-size: 22px;\n    min-width: 150px;\n  }\n\n  .transaction-total-wrap {\n    gap: 120px;\n  }\n\n  .admin-user-table-wrapper {\n    width: 70%;\n  }\n\n\n}\n\n@media (min-width: 420px) and (max-width: 768px) {\n  .dashboard-card {\n    width: 330px;\n    height: 194px;\n    margin: 0 auto;\n  }\n\n  .dashboard-card-2 {\n    width: 330px;\n    height: 194px;\n    margin: 0 auto;\n  }\n\n  .acc-transaction-header-wrapper {\n    position: fixed;\n    width: 90%;\n  }\n\n  .acc-transaction-header-wrapper {\n    position: fixed;\n    width: 90%;\n  }\n}\n\n@media (min-width: 576px) {\n  .container,\n  .container-sm {\n    max-width: 90%;\n  }\n}\n\n@media (min-width: 1600px) {\n  .acc-transaction-header-wrapper {\n    position: fixed;\n    width: 82%;\n  }\n\n  h2.wallet-box-text {\n    margin-top: 40px;\n  }\n\n  .wallet-balance-table-main-wrapper {\n    display: flex;\n    width: 57%;\n  }\n\n  .balance-acc {\n    margin: 0 auto;\n    margin-top: 81px;\n  }\n\n  .wallet-table-wrap2 {\n    width: 57%;\n  }\n\n  .spacing-wrapper {\n    margin-left: 150px;\n  }\n\n  .offcanvas-custom-large {\n    width: 700px !important;\n  }\n\n  div.dataTables_wrapper div.dataTables_paginate {\n    /* margin-right: 100px; */\n    /* position: fixed; */\n    right: 16%;\n    bottom: 20px;\n    background: #ffff;\n    margin-left: 80%;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 880px) {\n  .filter-select-wraper {\n    gap: 8px;\n  }\n}\n\n\n\n@media(min-width: 768px) and (max-width: 1199px){\n  .fiter-dropdown {\n    display: none;\n}\n\n.admin-user-table-wrapper {\n  width: 80%;\n}\n\n  .fiter-dropdown-mobile {\n    display: block;\n  }\n\n  .mobile-filter-wrap {\n    width: 200px;\n    margin-top: 20px;\n    padding: 15px 10px;\n    border: 1px solid var(--buttonColor);\n    border-radius: 5px;\n    outline: none;\n    color: #383838;\n    font-size: 16px;\n    font-weight: 300;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 20px;\n    cursor: pointer;\n}\n\n.mobile-filter-wrap h3 {\n    font-size: 20px;\n    margin: 0px;\n  }\n\n  .mobile-filter-wrap img{\n    width: 18px;\n  }\n\n  .transfer-history-header img {\n    width: 60px;\n}\n\n.search-icon img {\n  width: 20px;\n}\n\ntable.table.table-striped thead, tr, th {\n  font-size: 16px !important;\n}\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
